// extracted by mini-css-extract-plugin
export var content = "_7h-3";
export var list = "_7h-4";
export var settingsContent = "_7h-7";
export var settingsPanel = "_7h-8";
export var state = "_7h-6";
export var triggerBadge = "_7h-2";
export var triggerButton = "_7h-1";
export var triggerShell = "_7h-0";
export var unreadDot = "_7h-5";